var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', {
    staticClass: "redirect-card text-center",
    on: {
      "click": function($event) {
        return _vm.redirectToTMSPortal()
      }
    }
  }, [_c('span', {
    staticClass: "redirect-icon",
    attrs: {
      "title": "Click to Redirect TMS Portal"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToTMSPortal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  })]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 mt-2"
  }, [_vm._v("Raise Adhoc Vehicle Request")])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f0ab296","hasScoped":false}!./src/views/components/vehicleAdhocRequests/vehicleAdhocRequests.component.html
// module id = 1627
// module chunks = 1